<div class="chemical-names-container">
  <div class="chemical-names-item-container">
    <div class="chemical-names-item-input-container">
      <mat-form-field appearance="outline" class="chemical-names-form-field">
        <mat-label>{{ formFieldTitle }}</mat-label>
        <textarea matInput #chemicalNamesInput 
          [(ngModel)]="chemicalNames"  rows="3"
          class="chemical-names chemical-names-item-input"
          (keyup.enter)="updateChemicalNames($event)" 
          (keyup.escape)="cancelUpdate()" (blur)="updateChemicalNames($event)"></textarea>
        <mat-icon matSuffix (mousedown)="clearChemicalNamesInputField()">cancel</mat-icon>
      </mat-form-field>
    </div>
    <div class="input-error" *ngIf="hasFieldValidationError(formFieldName)">
      This is a required field.
    </div>
  </div>
  <div *ngIf="this.formType === 'FormF'" class="chemical-names-info chemical-names-info-text">
    Chemical Abstracts Service Index Name must be supplied, any other systematic names for the substance may also be listed.
  </div>
</div>